<div class="dataset-dropdown" (click)="onOutsideClick($event)">
  <div class="dropdown-header" (click)="toggleDropdown()">
    <div class="selected-value" [class.placeholder]="!selectedValue">
      {{ selectedDisplayText() }}
    </div>
    <div class="dropdown-arrow" [class.open]="isOpen">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <div class="dropdown-content" [class.open]="isOpen" *ngIf="isOpen">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="loading-spinner"></div>
      <span>Loading datasets...</span>
    </div>

    <!-- Dataset Options -->
    <div class="dataset-list" *ngIf="!isLoading && contentList.length > 0">
      <div
        class="dataset-item"
        *ngFor="let dataset of contentList"
        (click)="selectItem(dataset)"
        [class.selected]="selectedValue?.value === dataset.value">
        <span class="dataset-label">{{ dataset.label }}</span>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && contentList.length === 0">
      <div class="empty-icon">
        <img src="assets/icons/playground/no_dataset.svg" alt="no dataset" class="no-dataset-icon">
      </div>
      <div class="empty-message">No Dataset Sample Found!</div>
      <div class="empty-instruction">Follow the instructions below to create one.</div>
    </div>
  </div>
</div>
